// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ActivityFieldChange,
  ActivityFieldChangeFromJSON,
  ActivityFieldChangeToJSON,
} from "./";

/**
 * Additional metadata for the activity (e.g. release name, old/new verdict, field changes)
 * @export
 * @interface ActivityAuditInfo
 */
export interface ActivityAuditInfo {
  /**
   * Name of the release
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  releaseName?: string;
  /**
   * Previous verdict value
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  oldVerdict?: string;
  /**
   * New verdict value
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  newVerdict?: string;
  /**
   * List of field-level changes made in this activity
   * @type {Array<ActivityFieldChange>}
   * @memberof ActivityAuditInfo
   */
  changes?: Array<ActivityFieldChange>;
  /**
   * Type of the linked item (for risk link/unlink activities)
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  targetType?: ActivityAuditInfoTargetTypeEnum;
  /**
   * Id of the linked item (for risk link/unlink activities)
   * @type {number}
   * @memberof ActivityAuditInfo
   */
  targetId?: number;
  /**
   * Title of the linked item (for risk link/unlink activities)
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  targetTitle?: string;
  /**
   * Id of the test plan (for defect unlink activities)
   * @type {number}
   * @memberof ActivityAuditInfo
   */
  testPlanId?: number;
  /**
   * Group selected for the review that was started.
   * @type {number}
   * @memberof ActivityAuditInfo
   */
  reviewerGroup?: number;
  /**
   * Group name at the time the review started, retained for history.
   * @type {string}
   * @memberof ActivityAuditInfo
   */
  reviewerGroupName?: string;
  /**
   * User who started the review and became its assigned reviewer.
   * @type {number}
   * @memberof ActivityAuditInfo
   */
  reviewer?: number;
  /**
   * User IDs added to the reviewer group by this activity.
   * @type {Array<number>}
   * @memberof ActivityAuditInfo
   */
  addedReviewers?: Array<number>;
  /**
   * User IDs removed from the reviewer group by this activity.
   * @type {Array<number>}
   * @memberof ActivityAuditInfo
   */
  removedReviewers?: Array<number>;
}

export function ActivityAuditInfoFromJSON(json: any): ActivityAuditInfo {
  return {
    releaseName: !exists(json, "release_name")
      ? undefined
      : json["release_name"],
    oldVerdict: !exists(json, "old_verdict") ? undefined : json["old_verdict"],
    newVerdict: !exists(json, "new_verdict") ? undefined : json["new_verdict"],
    changes: !exists(json, "changes")
      ? undefined
      : (json["changes"] as Array<any>).map(ActivityFieldChangeFromJSON),
    targetType: !exists(json, "target_type") ? undefined : json["target_type"],
    targetId: !exists(json, "target_id") ? undefined : json["target_id"],
    targetTitle: !exists(json, "target_title")
      ? undefined
      : json["target_title"],
    testPlanId: !exists(json, "test_plan_id")
      ? undefined
      : json["test_plan_id"],
    reviewerGroup: !exists(json, "reviewer_group")
      ? undefined
      : json["reviewer_group"],
    reviewerGroupName: !exists(json, "reviewer_group_name")
      ? undefined
      : json["reviewer_group_name"],
    reviewer: !exists(json, "reviewer") ? undefined : json["reviewer"],
    addedReviewers: !exists(json, "added_reviewers")
      ? undefined
      : json["added_reviewers"],
    removedReviewers: !exists(json, "removed_reviewers")
      ? undefined
      : json["removed_reviewers"],
  };
}

export function ActivityAuditInfoToJSON(value?: ActivityAuditInfo): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    release_name: value.releaseName,
    old_verdict: value.oldVerdict,
    new_verdict: value.newVerdict,
    changes:
      value.changes === undefined
        ? undefined
        : (value.changes as Array<any>).map(ActivityFieldChangeToJSON),
    target_type: value.targetType,
    target_id: value.targetId,
    target_title: value.targetTitle,
    test_plan_id: value.testPlanId,
    reviewer_group: value.reviewerGroup,
    reviewer_group_name: value.reviewerGroupName,
    reviewer: value.reviewer,
    added_reviewers: value.addedReviewers,
    removed_reviewers: value.removedReviewers,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ActivityAuditInfoTargetTypeEnum {
  TestCase = "test_case",
  Requirement = "requirement",
  Defect = "defect",
}
